import { GlobalDisableSettings } from '@common-modules/shared/config/global-disable-settings';

export const ctGlobalDisableSettings: GlobalDisableSettings = {
  disableHELevelsAllQuery: true,
  disableSingleAppAttributeQuery: true,
  disableEventChart: true, // The event chart needs refactor if we want to use it on CT
  disableUoMQuery: true,
};
